import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Theme } from '../enum/Theme';
import Card from '../comps/Card';
import { observer } from 'mobx-react';
import { userStore } from '../stores/UserStore';


const Dash = observer(() => {
  const { users } = userStore;

  const cardsData = [
    {
      titleTop: 'Usuários',
      title: 'cadastrados',
      number: users.length.toString(),
      subItems: [
        { value: users.length.toString(), label: 'Ativos', color: Theme.foreground },
      ],
    },
   
  ];


  return (
    <View style={styles.container}>
      <View style={styles.cardsContainer}>
        {cardsData.map((card, index) => (
          <Card
            key={index}
            titleTop={card.titleTop}
            title={card.title}
            number={card.number}
            subItems={card.subItems}
          />
        ))}
      </View>

      
    </View>
  );
});

export default Dash;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 40,
    backgroundColor: '#F2F2F2',
  },
  cardsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 20,
  },
  cardTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 20,
    color: Theme.foreground,
  },
  cardTitleTop: {
    fontSize: 16,
    color: Theme.foreground,
  },
});
